import React, { useEffect, useState } from 'react';
import _ from 'lodash';

import './gt.js';

import { useLang } from '../../hookTool';

function GeeTest(props = {}) {
  const {
    gt,
    product = 'bind',
    challenge,
    https = true,
    success,
    new_captcha,
    area,
    next_width = '300px',
    bg_color = 'black',
    onSuccess = _.noop,
    onClose = _.noop,
    onError = _.noop,
  } = props;

  const { t } = useLang();
  const currentLang = t('locale');
  const { reset, setReset } = useState(false);

  const initGeetest = () => {
    window.initGeetest &&
      window.initGeetest(
        {
          gt,
          lang: currentLang,
          product,
          challenge,
          https,
          new_captcha,
          offline: !success,
          area,
          next_width,
          bg_color,
        },
        (captchaObj) => {
          if (product !== 'bind') {
            captchaObj.appendTo('#captchaBox'); // 将验证按钮插入到宿主页面中captchaBox元素内
          }
          captchaObj
            .onReady(() => {
              captchaObj.verify();
            })
            .onSuccess(() => {
              onSuccess(captchaObj.getValidate());
            })
            .onClose(() => {
              onClose();
              captchaObj.reset();
              captchaObj.destroy();
            })
            .onError((error) => {
              onError();
              if (error.code === 'error_12') {
                // 极验错误后应重置，可再次唤起极验
                setReset(true);
              } else {
                captchaObj.reset();
                captchaObj.destroy();
              }
            });
        },
      );
  };

  useEffect(() => {
    if (gt || reset) {
      initGeetest();
    }
  }, [gt, reset]);

  return <div id="captchaBox" />;
}

export default GeeTest;
